import React, { Component } from 'react';
import {
  currentTimezone,
  formatTime,
  hourToAmPm,
} from '@/util/helpers/time-helpers';

class SelectHour extends Component {
  selectHour() {
    const options = [...Array(24).keys()].map((n) => {
      const key = n < 10 ? `0${n}` : n;
      const amPm = hourToAmPm(n);
      return (
        <option key={key} value={key}>
          {`${key}:00 / ${amPm}`}
        </option>
      );
    });
    return options;
  }

  onChangeTime(e) {
    const dt = new Date();
    dt.setHours(e.currentTarget.value);
    dt.setMinutes(0);
    dt.setSeconds(0);
    dt.setMilliseconds(0);
    // convert to UTC time
    const utcTimestamp = dt.toISOString();
    this.props.onChange(utcTimestamp);
  }

  render() {
    const { chosenTime } = this.props;

    const time = chosenTime ? formatTime(chosenTime).split(':')[0] : null;

    return (
      <div className="">
        <select
          value={time}
          className="form-control set-input-height select-date"
          onChange={(e) => this.onChangeTime(e)}
        >
          {this.selectHour()}
        </select>
        {this.props.hideTimeZone ? null : <span>{currentTimezone()}</span>}
      </div>
    );
  }
}

export default SelectHour;
